import get from 'lodash/get';
import { gridConfig } from '@client/config';
import { isRetina, getPixelRatio } from '@client/helpers';

export const getMobileImageSize = () => {
    const pixelRatio = getPixelRatio();

    if (pixelRatio >= 1.5 && pixelRatio < 2.5) {
        return 'xhdpi';
    }
    if (pixelRatio >= 2.5) {
        return 'xxhdpi';
    }

    return 'hdpi';
};

export const getBannerDesktopImage = (tab) => {
    const highResIamge = get(tab, 'highlight.imagesHighres.large', null);
    const lowResIamge = get(tab, 'highlight.images.large', null);

    return (isRetina() && highResIamge) ? highResIamge : lowResIamge;
};

export const getBannerMobileImage = (tab) => {
    const size = getMobileImageSize();

    return get(tab, `highlight.images.${size}`, null);
};

export const getCampaignGridImage = (campaign, dimension) => {
    const size = gridConfig.open.gridImagesNames[dimension];
    const quality = isRetina() ? 'highres' : 'normal';

    return get(campaign, `images.${size}.${quality}`);
};

export const getCampaignMobileImage = (campaign) => {
    const size = getMobileImageSize();

    return get(campaign, `images.${size}.normal`, null);
};
